<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        :fullscreen="true"
        class="create_dialog"
    >
      <template #title>
        <div class="title_dialog">
          <span>Sửa phiếu khảo sát</span>
        </div>
      </template>
      <div class="body_dialog">
        <el-row type="flex" :gutter="30">
          <el-col :span="8">
            <div class="section_setting">
              <el-row :gutter="6">
                <el-col :span="24">
                  <div
                      :class="[
                          'wrap_setting border_element_setting gutter_row',
                          isValid.dateTime ? 'border_error' : ''
                      ]"
                  >
                    <div :class="!isAnswer ? 'container_setting active_click' : 'container_setting disable_click'">
                      <span :class="!isAnswer ? 'label_settings' : 'disable_click'"
                            @click="!isAnswer && handleChangeIsApplyTime">Thời gian áp dụng:</span>
                      <el-switch :disabled="isAnswer" v-model="isApplyTime"/>
                    </div>

                    <div v-if="isApplyTime" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #DCDFE6">
                      <el-row type="flex" :gutter="20">
                        <el-col :span="12">
                          <div>
                            <span class="label_time">Ngày bắt đầu: </span>
                            <el-date-picker
                                class="picker_time_apply"
                                v-model="defaultDataForm.fistDay"
                                type="date"
                                placeholder="Chọn ngày bắt đầu"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                :disabled="isAnswer"
                            >
                            </el-date-picker>
                          </div>
                        </el-col>

                        <el-col :span="12">
                          <div>
                            <span class="label_time">Ngày kết thúc: </span>
                            <el-date-picker
                                class="picker_time_apply"
                                v-model="defaultDataForm.lastDay"
                                type="date"
                                placeholder="Chọn ngày kết thúc"
                                :picker-options="pickerLastDayOptions"
                                value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy"
                                :disabled="disabledLastDay"
                            >
                            </el-date-picker>
                          </div>
                        </el-col>
                      </el-row>

                      <div v-if="isValid.dateTime" class="message_error">
                        *Vui lòng chọn thời gian
                      </div>
                    </div>
                  </div>
                </el-col>

                <el-col :span="24">
                  <div class="wrap_setting border_element_setting gutter_row">
                    <div class="container_setting">
                      <span class="label_settings">Phạm vi:</span>
                      <el-select
                          v-model="scopeForm"
                          class="selected_scope"
                          placeholder="Chọn phạm vi"
                          @change="handleChangeScopeApply">
                        <el-option
                            v-for="(item, index) in listScopeApply"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #DCDFE6">
                      <el-row type="flex" :gutter="4">
                        <el-col span="12">
                          <div style="display: flex; justify-content: end">
                            <el-button
                                class="button_choice"
                                :type="isShowButtonScope.class ? 'primary' : 'info'"
                                size="medium"
                                :plain="true"
                                :disabled="!isShowButtonScope.class"
                                @click="handleShowApplyKid"
                            >
                              Lớp
                            </el-button>
                          </div>
                        </el-col>

                        <el-col span="12">
                          <div style="display: flex">
                            <el-button
                                class="button_choice"
                                :type="isShowButtonScope.employee ? 'primary' : 'info'"
                                size="medium"
                                :plain="true"
                                :disabled="!isShowButtonScope.employee"
                                @click="handleShowApplyEmployee"
                            >
                              Nhân sự
                            </el-button>
                          </div>
                        </el-col>
                      </el-row>
                    </div>

                    <div class="container_apply">
                      <el-row type="flex" :gutter="4">
                        <el-col :span="12">
                          <div :class="!isShowButtonScope.class ? 'element_apply disabled_apply' : 'element_apply'">
                            <h4 style="text-align: center">Danh sách học sinh</h4>
                            <div class="answer_apply">
                              <div v-for="(kid, index) in applyForm.kids" :key="index"
                                   style="font-size: 12px; margin-bottom: 8px; display: flex">
                                <div style="margin-right: 4px">
                                  <i style="color: #67C23A" class="el-icon-circle-check"/>
                                </div>
                                <div>
                                  {{ kid.kidsName }} - {{ parseKidStatusVietnamese(kid.statusKids) }}( {{
                                    kid.className
                                  }} )
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-col>

                        <el-col :span="12">
                          <div :class="!isShowButtonScope.employee ? 'element_apply disabled_apply' : 'element_apply'">
                            <h4 style="text-align: center">Danh sách nhân sự</h4>
                            <div class="answer_apply">
                              <div>
                                <div v-for="(employee, index) in applyForm.employees" :key="index"
                                     style="font-size: 12px; margin-bottom: 8px; display: flex">
                                  <div style="margin-right: 4px">
                                    <i style="color: #67C23A" class="el-icon-circle-check"/>
                                  </div>
                                  <div>
                                    {{ employee.teacherName }} (
                                    <span
                                        v-for="(department, index) in employee.departmentTeacherApplyList"
                                        :key="index"
                                    >
                                      {{ department.departmentName }}
                                      <span v-if="index !== employee.departmentTeacherApplyList.length - 1">
                                        -
                                      </span>
                                    </span>
                                    )
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-col>

                <el-col :span="24">
                  <div class="wrap_setting border_element_setting gutter_row">
                    <div class="container_setting">
                      <span :class="!isAnswer ? 'label_settings' : 'disable_click'">Cho phép sửa trả lời: </span>
                      <el-radio-group v-model="defaultDataForm.fix" class="radio_options" :disabled="isAnswer">
                        <el-radio :label="true">Có</el-radio>
                        <el-radio :label="false">Không</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </el-col>

                <el-col :span="14">
                  <div class="wrap_setting border_element_setting gutter_row">
                    <div class="container_setting">
                      <span :class="!isAnswer ? 'label_settings' : 'disable_click'" @click="handleChangeAnonymous">Cho phép trả lời ẩn danh</span>
                      <el-switch v-model="defaultDataForm.anonymous" :disabled="isAnswer"/>
                    </div>
                  </div>
                </el-col>

              </el-row>

              <div class="dialog-footer">
                <el-button @click="handleClose" type="danger">
                  <i class="  el-icon-circle-close"/>
                  Hủy bỏ
                </el-button>

                <el-button type="success" @click="!isAnswer ? handleSaveForm() : handleApply()">
                  <i class="el-icon-circle-check"/>
                  Lưu
                </el-button>
              </div>
            </div>
          </el-col>

          <el-col :span="16">
            <div class="wrap_survey_form" v-loading="isLoadingCloneForm">
              <div class="survey_form">
                <div style="display: flex; justify-content: center">
                  <div class="form_wrap_custom">

                    <!--    Ảnh mở đầu phiếu    -->
                    <section class="wrap_image_form radius border">
                      <el-image class="main_image" :src="defaultDataForm.imgWeb"/>
                      <el-upload
                          ref="uploadImageSurveyForm"
                          action="#"
                          list-type="picture-card"
                          :auto-upload="false"
                          file-list="listImageForm"
                          class="upload_image_form"
                          :limit="1"
                          accept="image/*"
                          :show-file-list="true"
                          :on-change="handleUploadImage"
                          :class="{ hideUpload: listImageForm.length > 0 }"
                          :disabled="isAnswer"
                      >
                        <i
                            :style="{ cursor: isAnswer ? 'not-allowed':'pointer' }"
                            class="el-icon-plus"
                        />

                        <template #file="scope">
                          <div class="container_image">
                            <img
                                class="el-upload-list__item-thumbnail"
                                :src="scope.file.url" alt="Ảnh"
                            >

                            <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(scope.file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>

                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemoveImage(scope.file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
              </span>
                          </div>
                        </template>
                      </el-upload>
                    </section>

                    <!--    Phần tiêu đề và mô tả phiếu    -->
                    <section class="header_survey_form radius border element_form">
                      <div>
                        <el-input
                            type="text"
                            placeholder="Tiêu đề phiếu khảo sát"
                            v-model="defaultDataForm.title"
                            :maxlength="100"
                            :show-word-limit="true"
                            :class="[
                                'header_survey_title',
                                isValid.title ? 'field_error' : ''
                                ]"
                            @blur="handleChangeInputHeader()"
                            :disabled="isAnswer"
                        />
                        <div v-if="isValid.title" class="message_error">*Vui lòng nhập tiêu để cho phiếu</div>
                      </div>

                      <el-input
                          type="textarea"
                          placeholder="Mô tả phiếu khảo sát"
                          v-model="defaultDataForm.description"
                          :maxlength="500"
                          :show-word-limit="true"
                          :autosize="{minRows: 3, maxRows: 6}"
                          :rows="3"
                          class="header_survey_description"
                          :disabled="isAnswer"
                      />
                    </section>

                    <!--    Phần câu hỏi phiếu    -->
                    <section class="wrap_question" ref="wrapQuestion">
                      <div
                          class="radius border element_form"
                          v-for="(question, index) in defaultDataForm.questionResponseList"
                          :key="index"
                          :ref="`elementForm-${index}`"
                          @click="!isAnswer && handleElementClick(index)"
                      >
                        <div class="element_body">
                          <el-row type="flex" :gutter="14">
                            <el-col :span="14">
                              <div class="element_question">
                                <el-input
                                    type="text"
                                    placeholder="Câu hỏi"
                                    v-model="question.questionText"
                                    :maxlength="1000"
                                    :show-word-limit="true"
                                    @blur="handleChangeTitleQuestion(index)"
                                    :disabled="isAnswer"
                                />

                                <!--   Với câu hỏi văn bản   -->
                                <el-input
                                    v-if="question.typeQuestion === 'Text'"
                                    type="textarea"
                                    placeholder="Văn bản trả lời"
                                    :maxlength="500"
                                    :show-word-limit="true"
                                    :rows="3"
                                    :disabled="true"
                                    :autosize="{minRows: 3, maxRows: 6}"
                                />

                                <!-- Với câu hỏi hộp kiểm (checkbox) -->
                                <div
                                    v-if="question.typeQuestion === 'CheckBox'"
                                    class="wrap_checkbox"
                                >
                                  <el-checkbox
                                      :disabled="true"
                                      v-for="(item, indexOption) in question.valueQuestionArray"
                                      :label="item.value"
                                      :key="indexOption"
                                      class="container_checkbox"
                                  >
                                    <div style="display: inline-block">
                                      <el-input
                                          type="text"
                                          placeholder="Tuỳ chọn"
                                          v-model="item.value"
                                          :maxlength="100"
                                          :show-word-limit="true"
                                          style="width: 100%"
                                          class="checkbox_options"
                                          @blur="handleChangeValueQuestion(index, indexOption)"
                                          :disabled="isAnswer"
                                      />
                                    </div>
                                    <div
                                        v-if="question.valueQuestionArray.length > 1 && !isAnswer"
                                        style="display: inline-block; margin-left: 30px; font-size: 16px; color: #000; cursor: pointer;">
                                      <i class="el-icon-close"
                                         @click="handleRemoveOptions(question.valueQuestionArray, index)"/>
                                    </div>
                                  </el-checkbox>
                                  <template>
                                    <div
                                        v-if="!isAnswer"
                                        class="add_option"
                                        @click="handleFocusAddOptions(question.valueQuestionArray, `inputAddOptions-${index}`)"
                                    >
                                      <i class="el-icon-circle-plus"/>
                                      <span style="font-weight: 900">Thêm</span>
                                    </div>
                                  </template>
                                </div>

                                <!--   Với câu hỏi trắc nghiệm (radio)  -->
                                <div
                                    v-if="question.typeQuestion === 'Radio'"
                                    class="wrap_checkbox"
                                >
                                  <el-radio
                                      :disabled="true"
                                      v-for="(item, indexOption) in question.valueQuestionArray"
                                      :label="item.value"
                                      :key="indexOption"
                                      class="container_checkbox"
                                  >
                                    <div style="display: inline-block">
                                      <el-input
                                          type="text"
                                          placeholder="Tuỳ chọn"
                                          v-model="item.value"
                                          :maxlength="100"
                                          :show-word-limit="true"
                                          style="width: 100%"
                                          class="checkbox_options"
                                          @blur="handleChangeValueQuestion(index, indexOption)"
                                          :disabled="isAnswer"
                                      />
                                    </div>
                                    <div
                                        v-if="question.valueQuestionArray.length > 1 && !isAnswer"
                                        style="display: inline-block; margin-left: 30px; font-size: 16px; color: #000; cursor: pointer;">
                                      <i class="el-icon-close"
                                         @click="handleRemoveOptions(question.valueQuestionArray, index)"/>
                                    </div>
                                  </el-radio>
                                  <template>
                                    <div
                                        v-if="!isAnswer"
                                        class="add_option"
                                        @click="handleFocusAddOptions(question.valueQuestionArray, `inputAddOptions-${index}`)"
                                    >
                                      <i class="el-icon-circle-plus"/>
                                      <span style="font-weight: 900">Thêm</span>
                                    </div>
                                  </template>
                                </div>

                                <!--   Với câu hỏi chọn điểm   -->
                                <div v-if="question.typeQuestion === 'Point'">
                                  <div style="display: flex; padding-left: 18px; gap: 0 14px;">
                                    <div
                                        v-for="(item, index) in 10"
                                        :key="index"
                                    >
                                      <div
                                          style="
                                          display: flex;
                                          justify-content: center">
                                        <span
                                            class="option_point"
                                        >
                                          {{ item }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!--   Với câu hỏi đánh giá (Sao)   -->
                                <div v-if="question.typeQuestion === 'Star'">
                                  <div style="display: flex; gap: 0 10px; padding-left: 18px;">
                                    <span v-for="item in 5" :key="item" class="icon_star">
                                      <i class="el-icon-star-off"/>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </el-col>

                            <el-col :span="10">
                              <div style="display: flex; justify-content: end">
                                <el-select
                                    v-model="question.typeQuestion"
                                    style="width: 220px"
                                    @change="(value) => handleChangeTypeQuestion(question, value)"
                                    @focus="handleElementClick(index)"
                                    :disabled="isAnswer"
                                >
                                  <el-option
                                      v-for="(item, index) in typeQuestionOptions"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value">
                                    <div style="display: flex; gap: 0 20px; height: 100%">
                                    <span style="display: flex; padding: 5px"><el-image
                                        :src="item.icon"></el-image></span>
                                      <span style="font-weight: 600">{{ item.label }}</span>
                                    </div>
                                  </el-option>
                                </el-select>
                              </div>
                            </el-col>

                          </el-row>
                        </div>

                        <div class="element_footer">
                          <span :style="{cursor: !isAnswer ? 'pointer' : 'not-allowed'}" @click="!isAnswer && handleCloneQuestion(index)">
                            <i class="el-icon-copy-document"/>
                          </span>

                          <span :style="{cursor: !isAnswer ? 'pointer' : 'not-allowed'}"
                                v-if="defaultDataForm.questionResponseList.length > 1"
                                @click="!isAnswer && handleRemoveQuestion(index)">
                            <i class="el-icon-delete"/>
                          </span>

                          <div class="wrap_require">
                            <span class="label_require">Bắt buộc</span>
                            <el-switch v-model="question.obligatory" :disabled="isAnswer"/>
                          </div>
                        </div>
                      </div>

                      <div
                          class="scroll_tasks" ref="scrollTasks"
                          v-if="defaultDataForm.questionResponseList.length > 0"
                      >
                        <el-tooltip placement="top" v-if="!isAnswer">
                          <div slot="content">Thêm câu hỏi</div>
                          <span class="btn_scroll_tasks"
                                @click="!isAnswer && handleAddNewQuestion(currentQuestionIndex)">
                            <i class="el-icon-circle-plus-outline"/>
                          </span>
                        </el-tooltip>

                        <div v-else>
                          <span class="btn_scroll_tasks"
                                @click="!isAnswer && handleAddNewQuestion(currentQuestionIndex)">
                            <i class="el-icon-circle-plus-outline"/>
                          </span>
                        </div>
                      </div>
                    </section>

                    <!--    Phần các nút tác vụ chung cho phiếu    -->
                    <section>
                      <div class="wrap_button_tasks">

                        <!--      Thêm câu hỏi mới vào cuối phiếu      -->
                        <el-tooltip placement="top" v-if="!isAnswer">
                          <div slot="content">Thêm câu hỏi</div>
                          <el-button circle
                                     @click="!isAnswer && handleAddNewQuestion(defaultDataForm.questionResponseList.length - 1)">
                            <i class="el-icon-plus"/>
                          </el-button>
                        </el-tooltip>

                        <div v-else>
                          <el-button circle
                                     @click="!isAnswer && handleAddNewQuestion(defaultDataForm.questionResponseList.length - 1)">
                            <i class="el-icon-plus"/>
                          </el-button>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>
    </el-dialog>

    <!--   Hiển thị chi tiết ảnh   -->
    <el-dialog top="40px" class="dialog_image" width="30%" :visible.sync="isDialog.dialogVisibleImage">
      <img width="100%" :src="isDialog.dialogImageUrl" alt="Ảnh phiếu">
    </el-dialog>

    <ApplyKidSurveyForm
        :is-open="isDialogApply.kid"
        @closeDialog="handleCloseDialogApplyKid"
        @confirmData="handleConfirmKidsApply"
        ref="applyKidSurveyForm"
    />

    <ApplyEmployeeSurveyForm
        :is-open="isDialogApply.employee"
        @closeDialog="handleCloseDialogApplyEmployee"
        @confirmData="handleConfirmEmployeesApply"
        ref="applyEmployeeSurveyForm"
    />
  </div>
</template>

<script>

import icon from "@/assets/icons";
import Vue from "vue";
import SurveyForm from "@/services/SurveyForm";
import ApplyEmployeeSurveyForm from "@/views/survey_form/dialog/ApplyEmployeeSurveyForm.vue";
import ApplyKidSurveyForm from "@/views/survey_form/dialog/ApplyKidSurveyForm.vue";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";

export default {
  components: {ApplyKidSurveyForm, ApplyEmployeeSurveyForm},
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      pickerFistDayOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },
      pickerLastDayOptions: {
        disabledDate: (time) => {
          const fistDay = new Date(this.defaultDataForm.fistDay);
          return time.getTime() <= fistDay.getTime();
        },
      },
      defaultDataForm: {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "Mô tả phiếu khảo sát",
        anonymous: false,
        fix: false,
        fistDay: "",
        lastDay: "",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      },
      typeQuestionOptions: [
        {
          icon: icon.text,
          label: "Văn bản",
          value: "Text"
        },
        {
          icon: icon.checkbox,
          label: "Hộp kiểm",
          value: "CheckBox"
        },
        {
          icon: icon.radio,
          label: "Trắc nghiệm",
          value: "Radio"
        },
        {
          icon: icon.point,
          label: "Điểm",
          value: "Point"
        },
        {
          icon: icon.rating,
          label: "Đánh giá",
          value: "Star"
        }
      ],
      currentQuestionIndex: 0,
      listImageForm: [],
      isDialog: {
        dialogVisibleImage: false,
        dialogImageUrl: "",
      },
      activeAnswer: "",
      idKidList: [],
      classStudentOptions: [],
      idTeacherList: [],
      classEmployeeOptions: [],
      isLoadingCloneForm: false,
      isApplyTime: false,
      scopeForm: "all",
      listScopeApply: [
        {
          value: "all",
          label: "Tất cả",
        },
        {
          value: "class",
          label: "Lớp"
        },
        {
          value: "employee",
          label: "Nhân sự"
        }
      ],
      isShowButtonScope: {
        class: true,
        employee: true,
      },
      isDialogApply: {
        kid: false,
        employee: false,
      },

      applyForm: {
        classes: [],
        kids: [],
        departments: [],
        employees: [],
      },
      timeForm: {
        firstDay: "",
        lastDay: "",
      },
      isFix: false,
      isAnswer: false,

      isValid: {
        title: false,
        dateTime: false,
      },
      disabledLastDay: true,
    }
  },

  watch: {
    isApplyTime(newVal) {
      const dataUpdate = this.defaultDataForm;
      const saveTime = this.timeForm;

      if (newVal) {
        dataUpdate.fistDay = saveTime.firstDay;
        dataUpdate.lastDay = saveTime.lastDay;
      } else {
        dataUpdate.fistDay = "";
        dataUpdate.lastDay = "";
      }
    },

    "defaultDataForm.fistDay"(newVal) {
      const isApplyTime = this.isApplyTime;
      const isAnswer = this.isAnswer;

      if (isAnswer) {
        this.isValid.dateTime = false;
        this.disabledLastDay = true;
      } else {
        if (isApplyTime) {
          this.isValid.dateTime = !newVal;
          this.disabledLastDay = !newVal;
          if (!newVal) {
            this.defaultDataForm.lastDay = "";
          }
        } else {
          this.isValid.dateTime = false;
        }
      }
    }
  },

  mixins: [
    parseInfoKidVietnameseMixin,
  ],

  methods: {
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },

    setCurrentQuestionIndex(index) {
      this.currentQuestionIndex = index;
    },

    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
      this.handleAnimationButtonAddByIndex(this.currentQuestionIndex);
    },

    resetData() {
      this.defaultDataForm = {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      }
      this.currentQuestionIndex = 0;
      this.isApplyTime = false;
      this.resetSurveyImageForm();
    },

    resetSurveyImageForm() {
      this.listImageForm = [];
      this.$refs.uploadImageSurveyForm.clearFiles();
    },

    handleFocusAddOptions(valueArray, refName) {
      const option = {
        value: `Tuỳ chọn`
      }

      valueArray.push(option);

      this.$refs[refName][0].blur();
    },

    handleRemoveOptions(valueArray, index) {
      valueArray.splice(index, 1);
    },

    handleCloneQuestion(index) {
      const elementClone = this.defaultDataForm.questionResponseList[index];
      const newElement = {
        questionText: elementClone.questionText,
        valueQuestion: elementClone.valueQuestion,
        valueQuestionArray: [],
        typeQuestion: elementClone.typeQuestion,
        obligatory: elementClone.obligatory,
      };
      const indexInsert = index + 1;

      elementClone.valueQuestionArray.map(item => {
        let newValueQuestion = {
          value: item.value,
        }
        newElement.valueQuestionArray.push(newValueQuestion);
      })

      this.defaultDataForm.questionResponseList.splice(indexInsert, 0, newElement);
    },

    handleRemoveQuestion(index) {
      this.defaultDataForm.questionResponseList.splice(index, 1);

      if (this.currentQuestionIndex === index) {
        this.handleElementClick(index - 1);
      }
    },

    handleChangeTypeQuestion(question, value) {
      switch (value) {
        case "CheckBox":
        case "Radio":
          if (question.valueQuestionArray.length === 0) {
            question.valueQuestionArray.push({value: "Tuỳ chọn"})
          }
          break;
        default:
          question.valueQuestionArray = [];
      }
    },

    handleAddNewQuestion(index) {
      const question = {
        questionText: `Câu hỏi`,
        valueQuestion: "",
        valueQuestionArray: [],
        typeQuestion: "Text",
        obligatory: false,
      }
      this.defaultDataForm.questionResponseList.splice(index + 1, 0, question);
      this.handleElementClick(index + 1);
    },

    handleElementClick(index) {
      this.setCurrentQuestionIndex(index);
      this.handleAnimationButtonAddByIndex(index);
    },

    handleAnimationButtonAddByIndex(index) {
      Vue.nextTick(() => {
        // Lấy phần tử `.element_form` được nhấn
        const elementForm = this.$refs[`elementForm-${index}`][0];
        const scrollTasks = this.$refs.scrollTasks;

        if (elementForm && scrollTasks) {
          const wrapQuestion = this.$refs.wrapQuestion;
          const wrapQuestionRect = wrapQuestion.getBoundingClientRect();
          const elementFormRect = elementForm.getBoundingClientRect();

          // Tính toán vị trí top tương đối của `.element_form` so với `.wrap_question`
          const topOffset = elementFormRect.top - wrapQuestionRect.top;

          // Cập nhật vị trí `top` của `.scroll_tasks`
          scrollTasks.style.top = `${topOffset}px`;
        }
      });
    },

    handleUploadImage(file, fileList) {
      this.listImageForm = fileList;
    },

    handleRemoveImage() {
      this.defaultDataForm.image = undefined;
      this.listImageForm.splice(0, 1);
    },

    handlePictureCardPreview(file) {
      this.isDialog.dialogImageUrl = file.url;
      this.isDialog.dialogVisibleImage = true;
    },

    handleSaveForm() {

      if (this.isValidDate() && !this.isValid.title) {
        const data = this.defaultDataForm;
        const kidsApply = this.applyForm.kids;
        const employeesApply = this.applyForm.employees;

        const formData = new FormData();

        formData.append("id", data.idForm)
        formData.append("title", data.title.trim());
        formData.append("description", data.description.trim());
        formData.append("anonymous", data.anonymous);
        formData.append("fix", data.fix);

        if (this.isApplyTime) {
          formData.append("fistDay", data.fistDay);
          if (data.lastDay) {
            formData.append("lastDay", data.lastDay);
          }
        }

        if (this.listImageForm.length > 0) {
          const file = this.listImageForm[0];
          console.log(file)
          formData.append("imgWeb", file.raw);

        }

        if (this.scopeForm === "class" || this.scopeForm === "all") {
          if (kidsApply.length > 0) {
            kidsApply.map((kid) => {
              formData.append(`idKidsList`, kid.idKid);
            })
          }
        }

        if (this.scopeForm === "employee" || this.scopeForm === "all") {
          if (employeesApply.length > 0) {
            employeesApply.map((employee) => {
              formData.append(`idTeacherList`, employee.idTeacher);
            })
          }
        }

        data.questionResponseList.map((item, index) => {
          if (item.idQuestion) {
            formData.append(`questions[${index}].id`, item.idQuestion);
          }
          formData.append(`questions[${index}].questionText`, item.questionText.trim());
          formData.append(`questions[${index}].typeQuestion`, item.typeQuestion);
          formData.append(`questions[${index}].obligatory`, item.obligatory);

          if (item.typeQuestion === "CheckBox" || item.typeQuestion === "Radio") {
            item.valueQuestion = item.valueQuestionArray.map(item => item.value).join(";");
            formData.append(`questions[${index}].valueQuestion`, item.valueQuestion);
          }
        });
        const loading = this.$loading({
          lock: true,
          text: 'Đang tải',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        SurveyForm.update(formData)
            .then((res) => {
              const data = res.data;

              this.$message({
                message: data.message,
                type: "success",
              });
              loading.close()
              this.handleClose();
            })
            .catch((err) => {
              console.log(err);
              loading.close()
              this.$message({
                message: err.data.message,
                type: "error",
              })

            })
      }
    },

    isValidDate() {
      const firstDay = this.defaultDataForm.fistDay;

      if (this.isApplyTime) {
        if (firstDay) {
          this.isValid.dateTime = false;
          return true;
        } else {
          this.isValid.dateTime = true;
          return false
        }
      } else {
        this.isValid.dateTime = false;
        return true;
      }
    },

    handleChangeInputHeader() {
      const data = this.defaultDataForm;
      this.isValid.title = data.title.trim() === "";
    },

    handleChangeTitleQuestion(index) {
      const field = this.defaultDataForm.questionResponseList;
      if (field[index].questionText.trim() === "") {
        field[index].questionText = `Câu hỏi`;
      }

      field[index].questionText.trim();
    },

    handleChangeValueQuestion(indexQuestion, indexOption) {
      const field = this.defaultDataForm.questionResponseList[indexQuestion];
      if (field.valueQuestionArray[indexOption].value.trim() === "") {
        field.valueQuestionArray[indexOption].value = `Tuỳ chọn`;
      }

      field.valueQuestionArray[indexOption].value.trim();
    },

    handleInitialData(id, answer) {
      this.isAnswer = answer;
      SurveyForm.getDataFormById(id)
          .then((res) => {
            const data = res.data.data;
            const applyKids = data.teacherAndKidsResponseApply.kidsPlusApplyList;
            const applyEmployees = data.teacherAndKidsResponseApply.teacherApplyList;

            data.questionResponseList.map((item) => {
              item["valueQuestionArray"] = [];
              if (item.typeQuestion === "CheckBox" || item.typeQuestion === "Radio") {
                item["valueQuestionArray"] = item.valueQuestion.split(";").map(item => ({value: item}));
              }
            });

            this.isApplyTime = (data.fistDay !== null);
            this.setDataApplyForm(applyKids, applyEmployees);
            this.defaultDataForm = data;
            this.saveTimeApply(data.fistDay, data.lastDay);
          })
          .catch((err) => {
            console.log(err);
          })
    },

    setDataApplyForm(applyKids, applyEmployees) {
      this.applyForm.kids = applyKids;
      this.applyForm.employees = applyEmployees;

      this.setDataClassesApply(applyKids);
      this.setDataDepartmentsApply(applyEmployees);
    },

    setDataClassesApply(applyKids) {
      const classesApply = [];

      applyKids.map((item) => {
        classesApply.push(item.idClass);
      })

      this.applyForm.classes = classesApply.filter((item, index, self) =>
          index === self.findIndex(obj => obj === item)
      );
    },

    setDataDepartmentsApply(applyEmployees) {
      const departmentsApply = [];

      applyEmployees.map(employee => {
        employee.departmentTeacherApplyList.map(department => {
          departmentsApply.push(department.idDepartment);
        })
      })

      this.applyForm.departments = departmentsApply.filter((item, index, self) =>
          index === self.findIndex(obj => obj === item)
      );
    },


    handleChangeAnonymous() {
      this.defaultDataForm.anonymous = !this.defaultDataForm.anonymous;
    },

    handleChangeIsApplyTime(value) {
      this.isApplyTime = !this.isApplyTime;
      console.log(value);
    },

    handleChangeScopeApply(value) {
      switch (value) {
        case "all":
          this.isShowButtonScope.class = true;
          this.isShowButtonScope.employee = true;
          break;
        case "class":
          this.isShowButtonScope.class = true;
          this.isShowButtonScope.employee = false;
          break;
        case "employee":
          this.isShowButtonScope.class = false;
          this.isShowButtonScope.employee = true;
          break;
      }
    },

    handleShowApplyKid() {
      this.isDialogApply.kid = true;
      this.$refs.applyKidSurveyForm.initialDataApply(this.applyForm.classes, this.getDataIdKids(this.applyForm.kids));
    },

    getDataIdKids(kids) {
      const idKids = [];

      kids.map(kid => idKids.push(kid.idKid));

      return idKids;
    },

    handleCloseDialogApplyKid() {
      this.isDialogApply.kid = false;
    },

    handleConfirmKidsApply(value) {
      this.applyForm.classes = value.classesApply;
      this.applyForm.kids = value.kidsApply;
      this.handleCloseDialogApplyKid();
    },

    handleCloseDialogApplyEmployee() {
      this.isDialogApply.employee = false;
    },

    handleConfirmEmployeesApply(value) {
      this.applyForm.departments = value.departmentsApply;
      this.applyForm.employees = value.employeesApply;
      this.handleCloseDialogApplyEmployee();
    },

    handleShowApplyEmployee() {
      this.isDialogApply.employee = true;
      this.$refs.applyEmployeeSurveyForm.initialDataApply(this.applyForm.departments, this.getDataIdEmployees(this.applyForm.employees));
    },

    getDataIdEmployees(employees) {
      const idEmployees = [];
      employees.map(employee => {
        idEmployees.push(employee.idTeacher);
      })
      return idEmployees;
    },

    saveTimeApply(firstDay, lastDay) {
      const dataTime = this.timeForm;

      dataTime.firstDay = firstDay;
      dataTime.lastDay = lastDay;
    },

    handleApply() {
      const idKids = this.getDataIdKids(this.applyForm.kids);
      const idTeachers = this.getDataIdEmployees(this.applyForm.employees);
      const idForm = this.defaultDataForm.idForm;

      SurveyForm.updateApply(idKids, idTeachers, idForm)
          .then((res) => {
            const data = res.data;

            this.$message({
              message: data.message,
              type: "success",
            });

            this.handleClose();
          })
          .catch((err) => {
            console.log(err);
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.create_dialog {
  /deep/ .el-dialog__header {
    background-color: #78a5e7;
    padding-top: 10px;
  }

  /deep/ .el-dialog__headerbtn:hover .el-dialog__close {
    color: #F56C6C;
  }
}

.dialog_image {
  /deep/ .el-dialog__header {
    background-color: transparent;
  }
}

.body_dialog {
  .wrap_survey_form {
    border: 1px solid #ccc;
    border-radius: 10px;

    .survey_form {
      height: 840px;
      padding: 30px 0;
      overflow: auto;

      .form_wrap_custom {
        width: 80%;
      }
    }
  }

  .section_setting {
    padding: 20px 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
}

.wrap_image_form {
  height: 192px;
  position: relative;

  .image_form {
    width: 100%;
    height: 100%;

    /deep/ .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

.radius {
  border-radius: 10px;
  overflow: hidden;
}

.border {
  border: 1px solid #dadce0;
}

.element_form {
  margin-top: 10px;
  padding: 40px 34px 30px 34px;
  display: flex;
  flex-direction: column;
  gap: 24px 0;
  box-shadow: 0 0 8px 0 #DCDFE6;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: initial;
    color: #000;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }

  /deep/ textarea::placeholder,
  /deep/ input::placeholder {
    color: #7b7b7b;
  }
}

.element_question {
  display: flex;
  flex-direction: column;
  gap: 24px 0;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: 0 56px 0 14px;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }
}

.header_survey_form {
  .header_survey_title {
    /deep/ input::placeholder {
      font-size: 22px;
      font-weight: 500;
    }

    /deep/ input {
      font-size: 22px;
      font-weight: 600;
      border-radius: initial;
      border: none;
      border-bottom: 1px solid #DCDFE6;
      padding: initial;
      color: #000;

      &:focus {
        border-bottom: 3px solid #78a5e7;
      }
    }
  }

  .header_survey_description {

  }

  .field_error {
    /deep/ input {
      border-bottom: 3px solid red;

      &:focus {
        border-bottom: 3px solid red;
      }
    }
  }
}

.element_footer {
  padding: 30px 0 0 0;
  border-top: 1px solid #dadce0;
  display: flex;
  justify-content: end;
  gap: 0 34px;
  align-items: center;
  font-size: 18px;
}

.wrap_require {
  display: flex;
  align-items: center;
  gap: 0 18px;
  padding-left: 32px;
  border-left: 1px solid #dadce0;

  .label_require {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
}

.wrap_checkbox {

}

.container_checkbox {
  margin-bottom: 10px;
}

.checkbox_options {
  /deep/ input {
    width: 350px;
  }
}

.option_point {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid #b4b4b4;
  border-radius: 6px;
  color: #4e4e4e;
  font-weight: 600;
  background-color: #d6d6d6;
  cursor: not-allowed;
}

.icon_star {
  font-size: 34px;
  cursor: not-allowed;
}

.wrap_button_tasks {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 14px;
}

.wrap_question {
  position: relative;

  .scroll_tasks {
    position: absolute;
    right: -61px;
    top: 0;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    width: 50px;
    min-height: 28px;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    gap: 10px 0;
    box-shadow: 0 0 8px 0 #DCDFE6;
    border: 1px solid #dadce0;
    transition: top 0.3s ease-in;

    .btn_scroll_tasks {
      font-size: 24px;
      cursor: pointer;
    }
  }
}

.upload_image_form {
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /deep/ .el-upload {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px dashed #000;
    z-index: 1;
    background-color: transparent;

    i {
      font-size: 20px;
    }
  }

  /deep/ .el-upload-list__item {
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .container_image {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover;
      object-position: center;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid #ccc
}

.main_image {
  width: 100%;
  height: 100%;

  /deep/ .el-image__inner {
    object-fit: cover;
    object-position: center;
  }
}

/deep/ .el-dialog__headerbtn i {
  color: #fff;
}

.selected_form {
  /deep/ .el-select {
    width: 100%;
  }
}

.wrap_right {

  .select_answer,
  .select_apply {
    padding: 10px 20px;

    /deep/ .el-collapse {
      border-top: none;
    }

    /deep/ .el-collapse-item__header {
      font-size: 14px;
    }
  }
}

.border_element_setting {
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

.wrap_setting {
  padding: 10px 16px;
  transition: all 0.5s ease-in;

  .container_setting {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .label_settings {

      &:hover {
        color: #409EFF;
      }
    }

    .disable_click {
      cursor: not-allowed;
    }

    .active_click {
      cursor: pointer;
    }
  }
}

.collapse_checkbox {
  /deep/ .el-checkbox {
    display: block;
  }
}

.collapse-item-limited {
  /deep/ .el-collapse-item__wrap {
    max-height: 200px;
    overflow-y: auto;
  }
}

.gutter_row {
  margin-bottom: 10px;
}

.label_time {
  margin-bottom: 6px;
  display: block;
}

.picker_time_apply {
  width: 100%;

  input {
    width: 100%;
  }
}

.element_apply {
  border: 1px solid #ccc;
  padding: 0 6px;
  border-radius: 6px;
  margin-top: 4px;
  transition: all 0.5s ease-in;
}

.answer_apply {
  padding-top: 6px;
  border-top: 1px solid #e0e0e0;
  height: 200px;
  overflow: auto;
}

.disabled_apply {
  background-color: #9a9a9a69;
}

.add_option {
  display: flex;
  gap: 0 24px;
  font-size: 15px;
  align-items: center;
  cursor: pointer;
  padding: 8px 0 0;
  width: 120px;

  &:hover {
    color: #409EFF;
  }
}

.message_error {
  margin-top: 6px;
  color: red;
}

.border_error {
  border: 1px solid red;
}

.button_choice {
  min-width: 100px;
}
.el-upload--picture-card i {
  font-size: 28px;
  color: #000000;
}


</style>